// axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://mittal-back-olb5.onrender.com/'
});

export default axiosInstance;

export const weburl = 'https://mittal-back-olb5.onrender.com/';
export const keyLogin = '6790rttec0545454d4a7a631';

